<template>
  <div style="height:100%;margin:-16px;">
    <Row>
      <ul class="tabs-bar clearfix">
        <li :class="[tabsName=='taskDetail'?'active':'','flexWidth']" @click="tabsName='taskDetail'">任务详情</li>
        <li :class="[tabsName=='lawyerAgreement'?'active':'','flexWidth']" @click="tabsName='lawyerAgreement'">律师协议</li>
        <!-- <li :class="[tabsName=='projectConfig'?'active':'','flexWidth']" @click="tabsName='projectConfig'">测购配置</li> -->
      </ul>
    </Row>
    <Row style="height: calc(100% - 50px);overflow:hidden;">
      <div
        v-if="tabsName=='taskDetail'" class="task-info"
        style="height:100%;" @scroll="getHeight"
      >
        <div class="anchor" :style="{top:height+'px'}">
          <p class="spec-p">
            <span class="icon-result"></span>
            <span class="line"></span>
            <span class="icon no-radius icon-table-01"></span>
          </p>
          <p :class="jumpCtrl=='Title-1'&&'active'" @click.prevent="anchorGo('Title-1')">
            <a href="" title="基本详情">
              <span class="line"></span>
              <span :class="['icon','icon-details-01',{'icon-active':jumpCtrl=='Title-1'}]"></span>
            </a>
          </p>
          <p :class="jumpCtrl=='Title-2'&&'active'" @click.prevent="anchorGo('Title-2')">
            <a href="" title="任务介绍">
              <span class="line"></span>
              <span :class="['icon','icon-lntroduction-01',{'icon-active':jumpCtrl=='Title-2'}]"></span>
            </a>
          </p>
          <p :class="jumpCtrl=='Title-3'&&'active'" @click.prevent="anchorGo('Title-3')">
            <a href="" title="案件材料">
              <span class="line"></span>
              <span :class="['icon','icon-material-01',{'icon-active':jumpCtrl=='Title-3'}]"></span>
            </a>
          </p>
          <p :class="jumpCtrl=='Title-4'&&'active'" @click.prevent="anchorGo('Title-4')">
            <a href="" title="查看附件">
              <span class="line"></span>
              <span :class="['icon','icon-folder-01',{'icon-active':jumpCtrl=='Title-4'}]"></span>
            </a>
          </p>
        </div>
        <div class="task-result" style="overflow:auto;height:100%;">
          <div id="Title-1" class="result-title">[ 基本详情 ]</div>
          <div class="result-content detail-content clearfix">
            <Row><Col span="3" class="left-label">任务编号：</Col><Col span="20" class="right-content">{{ taskDetail.code || "" }}</Col></Row>
            <Row><Col span="3" class="left-label">委托人：</Col><Col span="20" class="right-content">{{ taskDetail.customerName || "" }}</Col></Row>
            <Row><Col span="3" class="left-label">所属项目：</Col><Col span="20" class="right-content">{{ taskDetail.projName || "" }}</Col></Row>
            <Row>
              <Col span="3" class="left-label">侵权区域：</Col>
              <Col span="20" class="right-content">
                <fold-block
                  :text="locationList"
                  :max-num="1"
                  placement="bottom-start"
                  :width="300"
                />
              </Col>
            </Row>
            <Row><Col span="3" class="left-label">截止时间：</Col><Col span="20" class="right-content">{{ taskDetail.endDate || "" }}</Col></Row>
            <Row>
              <Col span="3" class="left-label">项目负责人：</Col>
              <Col span="20" class="right-content">
                {{ taskDetail.manager?(taskDetail.manager.name || ''):'' }}
                <Tooltip :content="taskDetail.manager?(taskDetail.manager.email || ''):''" theme="light">
                  <Icon type="md-mail" size="16" />
                </Tooltip>
                <Tooltip :content="taskDetail.manager?(taskDetail.manager.mobile || ''):''" theme="light">
                  <Icon type="md-phone-portrait" size="16" />
                </Tooltip>
              </Col>
            </Row>
          </div>
          <div id="Title-2" class="result-title">[ 任务介绍 ]</div>
          <div class="result-content clearfix" v-html="taskDetail.description || ''"></div>
          <div
            v-if="false" id="Title-3"
            class="result-title"
          >[ 案件材料 ]</div>
          <div v-if="false" class="result-content clearfix">
            <div class="result-subtitle">[诉讼文书模板]</div>
            <file-container type="two" />
            <div class="result-subtitle">[知名度证据]</div>
            <div class="result-subtitle">[维权指引]</div>
            <div class="result-subtitle">[权属材料]</div>
          </div>
          <div id="Title-4" class="result-title">
            [ 查看附件 ]
            <Button
              type="primary" size="small"
              :loading="loading" @click="$refs['materialsInfo'].packAll()"
            >一键打包</Button>
          </div>
          <div class="result-content clearfix">
            <materials-info
              v-bind="$attrs" ref="materialsInfo"
              :loading.sync="loading" :default-list="taskDetail.attachmentList || []"
              :read-only="true"
            />
          </div>
        </div>
      </div>
      <Row v-if="tabsName=='lawyerAgreement'" style="padding:10px;height:100%;overflow:auto;">
        <task-lawyer-price-info :id="taskDetail.id" />
      </Row>
      <Row v-if="tabsName=='projectConfig'">
        <Row class="detail-content">
          <Row><Col span="5" class="left-label">是否需要测购：</Col><Col span="16" class="right-content">{{ configData.isTestPurchase?"是":"否" }}</Col></Row>
          <Row v-if="configData.isTestPurchase">
            <Row><Col span="5" class="left-label">是否需要邮寄：</Col><Col span="16" class="right-content">{{ configData.isMailingSample?"是":"否" }}</Col></Row>
            <Row v-if="configData.isMailingSample"><Col span="5" class="left-label">商品邮寄给：</Col><Col span="16" class="right-content">{{ configData.merchandiseMailing=="C"?"客户":"安盾" }}</Col></Row>
            <Row v-if="configData.isMailingSample"><Col span="5" class="left-label">地址：</Col><Col span="16" class="right-content">{{ configData.address || "" }}</Col></Row>
          </Row>
        </Row>
      </Row>
    </Row>
  </div>
</template>
<script>
import foldBlock from '@/components/common/foldBlock/foldBlock.vue'
import materialsInfo from './../plugin/materialsInfo/materialsInfo.vue'
import fileContainer from '@/components/common/fileContainer/fileContainer.vue'
import taskLawyerPriceInfo from '../plugin/taskLawyerPriceInfo/index.vue'
export default {
  components: {
    fileContainer,
    foldBlock,
    taskLawyerPriceInfo,
    materialsInfo
  },
  props: ['taskDetail'],
  data () {
    return {
      jumpCtrl: 'Title-1',
      height: 15,
      flag: false,
      tabsName: 'taskDetail',
      configData: '',
      loading: false
    }
  },
  computed: {
    locationList() {
      if (this.taskDetail.missionScope === 'N') {
        return this.taskDetail.missionScopeZh
      } else {
        const location = []; const json = {}
        if (!this.taskDetail.locationList) { return }
        this.taskDetail.locationList.forEach(item => {
          if (item.flag) {
            if (!json[item.province]) {
              json[item.province] = item.provinceName
            }
          } else {
            location.push(item.cityName)
          }
        })
        for (const key in json) {
          location.push(json[key])
        }
        return location.join(',')
      }
    }
  },
  watch: {

  },
  created() {

  },
  beforeMount() {
    this.getPojectConfig()
  },
  mounted() {

  },
  updated() {

  },
  methods: {
    anchorGo(anchorName) {
      this.jumpCtrl = anchorName
      this.flag = true
      const anchorElement = document.getElementById(anchorName)
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView()
      }
    },
    getHeight(e) {
      if (!this.flag) {
        if (e.target.scrollTop >= document.getElementById('Title-2').offsetTop) {
          this.jumpCtrl = 'Title-2'
        } else if (e.target.scrollTop >= document.getElementById('Title-3').offsetTop) {
          this.jumpCtrl = 'Title-3'
        } else if (e.target.scrollTop >= document.getElementById('Title-4').offsetTop) {
          this.jumpCtrl = 'Title-4'
        } else {
          this.jumpCtrl = 'Title-1'
        }
      } else {
        this.flag = false
      }
    },
    // 获取项目测购配置
    getPojectConfig() {
      const url = `/business/test-purchase-config/${this.taskDetail.projId}`
      this.$get(url).then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.configData = res.data
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="sass">
 @import './taskInfo.scss'
</style>



// WEBPACK FOOTER //
// src/view/taskHall/myTask/taskInfo.vue